(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('montfalls-hero-audio')) {
    customElements.define('montfalls-hero-audio', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('.hero__audio-toggle');
        this.playButton = this.querySelector('.hero__play-toggle');
        this.hero = this.closest('.hero');
        this.hero.tabIndex = 0;
        this.hero.setAttribute('aria-label', this.dataset.keyboardLabel);
        this.hero.addEventListener('click', event => {
          if (event.target.closest('a, button, input, select, textarea, summary')) return;
          this.toggleAttribute('data-controls-visible');
        }, options);
        this.hero.addEventListener('keydown', event => {
          if (event.target !== this.hero) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleAttribute('data-controls-visible');
          } else if (event.key === 'Escape') {
            this.removeAttribute('data-controls-visible');
          }
        }, options);
        this.videos = [...this.closest('.hero').querySelectorAll('.hero__media-grid video')];
        this.visibleVideo = () => this.videos.find(video => video.getClientRects().length > 0);
        this.sync = () => {
          const video = this.visibleVideo();
          this.hidden = !video;
          const paused = !video || video.paused;
          this.playButton.dataset.paused = String(paused);
          this.playButton.setAttribute('aria-label', paused ? this.playButton.dataset.labelPlay : this.playButton.dataset.labelPause);
          this.playButton.title = this.playButton.getAttribute('aria-label');
          const audible = Boolean(video && !video.muted && !video.paused);
          this.button.setAttribute('aria-pressed', String(audible));
          this.button.setAttribute('aria-label', audible ? this.button.dataset.labelOff : this.button.dataset.labelOn);
          this.button.title = this.button.getAttribute('aria-label');
        };
        this.button.addEventListener('click', () => {
          const video = this.visibleVideo();
          if (!video) return;
          const enable = video.muted || video.paused;
          this.videos.forEach(item => { item.muted = true; });
          if (enable) {
            video.muted = false;
            video.play().then(() => this.sync()).catch(() => {
              video.muted = true;
              this.sync();
            });
          }
          this.sync();
        }, options);
        this.playButton.addEventListener('click', () => {
          const video = this.visibleVideo();
          if (!video) return;
          if (video.paused) {
            video.play().then(() => this.sync()).catch(() => this.sync());
          } else {
            this.videos.forEach(item => item.pause());
          }
          this.sync();
        }, options);
        this.videos.forEach(video => {
          ['volumechange', 'playing', 'pause', 'loadedmetadata'].forEach(event => video.addEventListener(event, this.sync, options));
        });
        this.resizeObserver = new ResizeObserver(() => {
          this.videos.forEach(video => { if (!video.getClientRects().length) video.muted = true; });
          this.sync();
        });
        this.resizeObserver.observe(this.closest('.hero'));
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.videos?.forEach(video => { video.muted = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
